import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import {IonicVue, menuController} from '@ionic/vue';
import VueAxios from 'vue-axios'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/css/styles.css';

/*pwa*/
import './registerServiceWorker'

/*store*/
import { store } from "@/store/formtemplate";
import { productsstore } from "@/store/products";

/*multilingual*/
import i18n from '@/locales/i18n'

const app = createApp(App)
  .use(IonicVue)
  .use(store)
  .use(productsstore)
  .use(VueAxios)
  .use(router)
  .use(i18n);

router.isReady().then(() => {
  app.mount('#app');
});

// wir redirected alle Aufrufe die nicht von einer Seite in der App kommen / kein redirect von uns waren oder nicht direk
// auf die Produkt Seiten gehen.
router.beforeEach((to, from, next) => {
  if(typeof from.name == "undefined" && typeof to.redirectedFrom == "undefined" && to.name !== 'produkt'){
    next({ path: '/home' });
  }else{
    next();
  }
})

// wir schließen nach jedem Seitenwechsel das Hauptmenü.
router.afterEach((to, from, failure) => {
  menuController.close('mainMenu');
});
